var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',[_c('Item',{attrs:{"title":"新增产品","content":"本月新增的产品"},on:{"change":_vm.handleChange,"expand":_vm.handleExpand}}),_c('div',{ref:"newProduct",staticStyle:{"height":"270px","margin-top":"28px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }